import React, { useState } from 'react';

// @tecton
import { HeaderLayout, Tabs, ViewLayout } from '@tecton/ComponentRedesign';
import Lookup from './Lookup';
import AllMaterializedFeatureViews from './AllMaterializedFeatureViews';
import WorkflowsDebug from './WorkflowsDebug';
import DeploymentScoreCard from './DeploymentScoreCard';

const Debug = () => {
  const indexPage = {
    tabName: 'Look Up',
    component: <Lookup />,
  };

  const [selectedTab, setSelectedTab] = useState<{ tabName: string; component: React.JSX.Element }>(indexPage);

  const pages = [
    indexPage,
    {
      tabName: 'All Materialized FVs',
      component: <AllMaterializedFeatureViews />,
    },
    {
      tabName: 'Workflows',
      component: <WorkflowsDebug />,
    },
    {
      tabName: 'Deployment Scorecard',
      component: <DeploymentScoreCard />,
    },
  ];

  const tabs = (
    <Tabs
      selectedTab={`${selectedTab?.tabName}`}
      items={pages.map((page) => ({ label: page.tabName, value: page.tabName }))}
      setSelectedTab={(tabName: string) => {
        const page = pages.find((tab) => tab.tabName === tabName) ?? indexPage;
        setSelectedTab(page);
      }}
    />
  );
  const header = <HeaderLayout breadcrumbs={[]} tabs={tabs} />;
  return <ViewLayout header={header} body={selectedTab.component} />;
};

export default Debug;
